export default __webpack_public_path__ + "static/media/12.29897cb7.svg";